<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$home"
				start
			/>
			<translate>Address</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<address-fields
						v-model="address"
						:country-name="countryName"
						:user-id="userId"
					/>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				v-can="'address.update'"
				color="primary"
				@click="SubmitAddress"
			>
				<translate>Save</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	inform, displayError,
} from 'laravel-front-library';

export default {
	name: 'AddressEdit',
	props: {
		countryName: {
			required: true,
			type: String,
		},
		userId: {
			required: true,
			type: [
				Number, String,
			],
		},
	},

	data () {
		return {
			address: {
				'street': '',
				'housenumber': '',
				'housenumberSuffix': '',
				'postalcode': '',
				'city': '',
				'doorCode': '',
				'floor': '',
				'administrativeArea': '',
				'house_name': '',
				'residentialArea': '',
				'country': '',
			},
		};
	},

	methods: {
		/**
		 * Submit form and update locale if necessary
		 */
		SubmitAddress () {
			axios.put(`/api/v0/users/userdata?id=${this.userId}`, {
				'address': this.address,
			}).then(() => {
				inform(this.$gettext('Updated'));
			}).catch((error) => {
				if (error.response.data.errors) {
					displayError(error.response.data.errors[0]);
				} else {
					displayError(this.$gettext('Something has gone wrong'));
				}
			});
		}
	}
};

</script>

<style scoped>

</style>
